module.exports = __webpack_public_path__ + "static/media/3.3ca31f59.jpg";